package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.repository.Mapper
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.launch

class SiteDaoImpl(private val sharedDatabase: SharedDatabase) : SiteDao {
    override suspend fun insertSite(site: Site) {
        CoroutineScope(Dispatchers.Default).launch {
            sharedDatabase { database ->
                database.appDatabaseQueries.transaction {
                    database.appDatabaseQueries.insertSite(
                        _id = site.id,
                        personAddress = Mapper().objectAsJson(site.addressObject),
                        personName = site.personName,
                        personEmail = site.personEmail,
                        personPhone = site.personPhone,
                        siteName = site.siteName,
                        parentId = site.parentId,
                        parentName = site.parentName,
                        workspaceId = site.workspaceId
                    )
                }
            }
        }
    }

    override suspend fun updateSite(site: Site) {
        CoroutineScope(Dispatchers.Default).launch {
            sharedDatabase { database ->
                database.appDatabaseQueries.transaction {
                    database.appDatabaseQueries.updateSite(
                        personName = site.personName,
                        personAddress = Mapper().objectAsJson(site.addressObject),
                        personPhone = site.personPhone,
                        siteName = site.siteName,
                        parentId = site.parentId,
                        parentName = site.parentName,
                        personEmail = site.personEmail,
                        workspaceId = site.workspaceId,
                        _id = site.id
                    )
                }
            }
        }
    }

    override suspend fun deleteAllSites() {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteAllSites()
        }
    }

    override suspend fun deleteSiteById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteSiteById(id)
        }
    }

    override suspend fun getSitesFlow(): Flow<List<com.hyperether.goodjob.database.Site>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSites()
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getSites(): List<com.hyperether.goodjob.database.Site> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSites()
                .awaitAsList()
        }
    }

    override suspend fun getSiteById(id: String): com.hyperether.goodjob.database.Site? {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSiteById(id)
                .executeAsList()
                .firstOrNull()
        }
    }

    override suspend fun getSitesByContactIdFlow(id: String): Flow<List<com.hyperether.goodjob.database.Site>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSitesByContactId(id)
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }

    override suspend fun getSitesByContactId(id: String): List<com.hyperether.goodjob.database.Site> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getSitesByContactId(id)
                .awaitAsList()
        }
    }
}